import { FormattedMessage } from 'react-intl'
import messages, { Message } from '@utils/messages'
import { CompanyNames } from './useCompanyName'
import { OrderType } from '@src/routes/OrderCenter/OrderDetail/orderDetailUtils'

const getCartCompanyName = (name) => {
  switch (name) {
    case CompanyNames.MilliporeSigma:
      return messages.ORDER_TYPE_MILLIPORESIGMA
    case CompanyNames.Merck:
      return messages.ORDER_TYPE_MERCK
    default:
      return messages.ORDER_TYPE_MILLIPORESIGMA
  }
}

export const getOrderTypeMessage = (
  companyName: CompanyNames,
  orderType?: string | null,
  isChinaUser?: boolean
): Message => {
  switch (orderType) {
    case 'marketplace':
      return messages.ORDER_TYPE_MARKETPLACE
    // case 'orc':
    //   return messages.ORDER_TYPE_EMD_MILLIPORE
    case OrderType.Emerald:
      return isChinaUser
        ? messages.ORDER_TYPE_MERCK_CHEMICALS
        : getCartCompanyName(companyName)
    default:
      return getCartCompanyName(companyName)
  }
}

export const renderOrderTypeText = (
  companyName: CompanyNames,
  orderType?: string | null,
  isChinaUser?: boolean
) => {
  return (
    <FormattedMessage
      {...getOrderTypeMessage(companyName, orderType, isChinaUser)}
    />
  )
}
